import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import DeleteCartHook from "../../hook/cart/DeleteCartHook";
import { ToastContainer } from "react-toastify";
import ApplyCouponHook from "../../hook/cart/ApplyCouponHook";
import notify from "../../hook/useNotification";
import { BiLeftArrowCircle } from "react-icons/bi";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { getOneUser } from "../../redux/actions/usersActions";
import { useDispatch, useSelector } from "react-redux";
import LoadingBar from "react-top-loading-bar";

const CartCheckout = ({
  totalPrice,
  totalPriceAfterDiscount,
  couponNameAfterApplay,
  cartItems,
  vendorId,
  totalShippingCost,
  loginCart=true
}) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [handleDeletCart] = DeleteCartHook();
  const [
    couponName,
    onChangeCoupon,
    handleSubmitCoupon,
    vatValue,
    settingsRes,
    res,
    couponId,
    loading,
  ] = ApplyCouponHook();

  let calcVatValue =
    totalPrice - (totalPrice * 100) / (Number(vatValue) + 100) || 0;
  const currencytype =
    Cookies.get("i18next") === "ar"
      ? settingsRes.data?.defaultCurrancy.ar
      : settingsRes.data?.defaultCurrancy.en;

  const [userData, setUserData] = useState();
  const [userLoading, setuserLoading] = useState(true);
  const [shippingCost, setShippingCost] = useState(0);
  const ref = useRef(null);

  var user = "";
  if (localStorage.getItem("user") != null) {
    user = JSON.parse(localStorage.getItem("user"));
  }

  console.log("cartItems", cartItems);

  useEffect(() => {
    ref.current.continuousStart();

    const get = async () => {
      setuserLoading(true);
      // console.log('vendorId');
      // console.log(vendorId);
      if (vendorId) await dispatch(getOneUser(vendorId._id));
      setuserLoading(false);
    };
    get();
  }, [vendorId]);
  const oneUser = useSelector((state) => state.usersReducers.oneUser);

  useEffect(() => {
    if (userLoading === false) {
      if (
        cartItems.reduce((a, b) => a + b.product?.weight * b.quantity, 0) /
          1000 <=
        parseInt(oneUser?.shipping?.wieghtNumber || 0)
      ) {
        setShippingCost(parseInt(oneUser?.shipping?.wieghtCost));
      } else {
        const productWeightSubtractShippingWeight =
          cartItems.reduce((a, b) => a + b.product?.weight * b.quantity, 0) /
            1000 -
          parseInt(oneUser?.shipping?.wieghtNumber);
        const cost =
          productWeightSubtractShippingWeight *
            parseInt(oneUser?.shipping?.wieghtExtraCost) +
          parseInt(oneUser?.shipping?.wieghtCost);

        // console.log('cost')
        setShippingCost(cost.toFixed(2));
      }
      ref.current.complete();
    }
  }, [userLoading]);

  const navigate = useNavigate();

  useEffect(() => {
    if (couponNameAfterApplay) {
      onChangeCoupon(couponNameAfterApplay);
    }
  }, [couponNameAfterApplay]);

  const handleCheckout = () => {
  
    if (!user){
       notify(t("Log in first"), "warn");

       setTimeout(() => {
        navigate("/login");  
       },2000);

       return;
    } 

    if (cartItems.length >= 1) {
      let totalCartPrice = cartItems[0]?.couponId?._id
        ? totalPriceAfterDiscount
        : totalPrice;

      console.log("totalCartPrice", totalCartPrice);

      navigate("/order/paymethoud", {
        state: { shippingCost, totalCartPrice },
      });
    } else {
      notify(t("Please add products to the cart"), "warn");
    }
  };

  console.log("totalPrice", totalPrice);
  console.log("totalPriceAfterDiscount", totalPriceAfterDiscount);
  console.log('totalShippingCost',totalShippingCost);

  return (
    <Row className=" d-flex justify-content-center  cart-checkout">
      <Helmet>
        <title>
          {` ${t("shopping cart")} -  ${
            Cookies.get("i18next") === "ar"
              ? settingsRes.data?.titleAr
              : settingsRes.data?.titleEn
          }`}{" "}
        </title>
      </Helmet>
      <LoadingBar
        color={settingsRes?.data?.primaryColor}
        ref={ref}
        shadow={true}
        height={4}
      />

      <Col xs="12" className="d-flex  flex-column  ">
        <div className="d-flex  ">
          <input
            value={couponName}
            onChange={(e) => onChangeCoupon(e.target.value)}
            className="copon-input d-inline text-center "
            placeholder={t("discount code")}
          />
          <button
            onClick={handleSubmitCoupon}
            disabled={loading}
            className="copon-btn d-inline "
            style={{
              backgroundColor: settingsRes?.data?.cartColor
                ? settingsRes?.data?.cartColor
                : settingsRes?.data?.primaryColor,
            }}
          >
            {loading ? <Spinner /> : `$${t("apply")}`}
          </button>
        </div>
        {!settingsRes?.data?.vatValue ||
        settingsRes?.data?.vatValue === "0" ||
        settingsRes?.data?.vatValue === "" ? null : (
          <div
            className="product-price d-inline w-100 my-1  border"
            style={{ height: "unset" }}
          >
            <div className=" p-2">
              {" "}
              {t("value added tax")}: {vatValue + "% "}
              {<BiLeftArrowCircle style={{ fontSize: "20px" }} />}
              {"  "}
              {calcVatValue.toFixed(2)} {currencytype}{" "}
            </div>
          </div>
        )}

        <div className="product-price d-inline w-100 my-1  border">
          {cartItems[0]?.couponId?._id
            ? `${totalPrice || 0} ${t("after discount")}  ...  ${
                totalPriceAfterDiscount || 0
              }${currencytype}`
            : `${totalPrice} ${currencytype}` || 0}
        </div>

        <div className="product-price d-inline w-100 my-1  border">
          {`${t("weight")}  ...  ${
            cartItems.reduce((a, b) => a + b.product?.weight * b.quantity, 0) /
            1000
          }  ${t("Kg")}`}
        </div>
        
        {
          loginCart &&<div className="product-price d-inline w-100 my-1  border">
          {
            // ${ isNaN(shippingCost) === true?0: shippingCost}
            `${t("Shipping charges")}  ... ${totalShippingCost}   ${t(
              "currency"
            )}`
          }
        </div>
        }
        

        <button
          onClick={handleCheckout}
          className="product-cart-add w-100 px-2"
          style={{
            backgroundColor: settingsRes?.data?.cartColor
              ? settingsRes?.data?.cartColor
              : settingsRes?.data?.primaryColor,
          }}
        >
          {t("Checkout")}
        </button>
        <button
          onClick={() => navigate("/")}
          className="product-cart-add w-100 px-2 mt-1"
          style={{
            backgroundColor: settingsRes?.data?.cartColor
              ? settingsRes?.data?.cartColor
              : settingsRes?.data?.primaryColor,
          }}
        >
          {t("Continue shopping")}
        </button>
        <Button
          onClick={handleDeletCart}
          variant="secondary"
          className="w-100 px-2 my-2 "
        >
          {t("delete cart")}
          <i className="fa fa-trash px-2" />
        </Button>

        {settingsRes?.data?.couponText && (
          <div className="btn btn-primary mt-4">
            {/* 11111111111111111 */}
            {settingsRes?.data?.couponText}
          </div>
        )}
      </Col>
      <ToastContainer />
    </Row>
  );
};

export default CartCheckout;
